import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
const OpenBetsScreen = React.lazy(
  () => import("../OpenBetsScreen/OpenBetsScreen")
);
const StatementScreen = React.lazy(
  () => import("../StatementScreen/StatementScreen")
);

const ReportsScreenRouter: React.FC = () => {
  return (
    <Switch>
      <Route
        path="/reports/openbets"
        render={() => (
          <Suspense
            fallback={
              <div className="fallback">
                <LoadingSpinner />
              </div>
            }
          >
            <OpenBetsScreen />
          </Suspense>
        )}
      />
      <Route
        path="/reports/statement"
        render={() => (
          <Suspense
            fallback={
              <div className="fallback">
                <LoadingSpinner />
              </div>
            }
          >
            <StatementScreen />
          </Suspense>
        )}
      />
      <Redirect to="/reports/openbets" />
    </Switch>
  );
};

export default ReportsScreenRouter;
